import BreyniaA1 from '../Breynia A/Breynia A (1).webp'
import BreyniaA2 from '../Breynia A/Breynia A (2).webp'
import BreyniaA3 from '../Breynia A/Breynia A (3).webp'
import BreyniaA4 from '../Breynia A/Breynia A (4).webp'
import BreyniaA5 from '../Breynia A/Breynia A (5).webp'
import BreyniaA6 from '../Breynia A/Breynia A (6).webp'

const BreyniaAimages =[
BreyniaA1,BreyniaA2,BreyniaA3,BreyniaA4,BreyniaA4,BreyniaA5,BreyniaA6
]

export default BreyniaAimages;